import { APP_ROUTES } from '@/config/constants';
import {
  ExploreAllFlyerboard,
  ExploreNewFlyers,
  FlyerDetails,
  JarContainer,
  LoginContainer,
  LoginDemo,
  LoginDrawer,
  MagicLinkExpiredContainer,
  MagicLinkSuccessContainer,
  Maps,
  SignUpContainer,
  Welcome,
} from '@/pages';
import { useReactiveVar } from '@apollo/client';
import { css } from '@emotion/css';
import { Route, Routes, useLocation } from 'react-router-dom';
import { BackButton, BottomNavigation } from './components';
import { openLoginDrawerVar } from './graphql/state';
import { pathMatches } from './utils/pathMatches';

const showBackButtonPages = [
  APP_ROUTES.welcome,
  APP_ROUTES.signUp,
  APP_ROUTES.magicLinkSuccess,
  APP_ROUTES.magicLinkExpired,
];

function NonAutenticatedLayout() {
  const { pathname } = useLocation();

  const showBottomNavPaths = [
    APP_ROUTES.exploreAllFlyers,
    APP_ROUTES.exploreNewFlyers,
    APP_ROUTES.jar,
  ];
  const shouldShowBottomNav = pathMatches(pathname, showBottomNavPaths);

  const openLoginDrawer = useReactiveVar(openLoginDrawerVar);

  const showBackButton = pathMatches(pathname, showBackButtonPages);

  return (
    <div className={styles.app}>
      <div className={styles.wrapper}>
        <div className={styles.content}>
          <div className={styles.container}>
            {showBackButton && (
              <div className={styles.backbutton}>
                <BackButton trackId="account_page" size={30} />
              </div>
            )}
            <Routes>
              <Route index element={<LoginContainer />} />
              <Route path={APP_ROUTES.login} element={<LoginContainer />} />
              <Route path={APP_ROUTES.loginDemo} element={<LoginDemo />} />
              <Route path={APP_ROUTES.welcome} element={<Welcome />} />
              <Route path={APP_ROUTES.signUp} element={<SignUpContainer />} />
              <Route path={APP_ROUTES.magicLinkSuccess} element={<MagicLinkSuccessContainer />} />
              <Route path={APP_ROUTES.magicLinkExpired} element={<MagicLinkExpiredContainer />} />
              <Route path={APP_ROUTES.exploreAllFlyers} element={<ExploreAllFlyerboard />} />
              <Route path={APP_ROUTES.exploreNewFlyers} element={<ExploreNewFlyers />} />
              <Route path={APP_ROUTES.jar} element={<JarContainer />} />
              <Route path={APP_ROUTES.flyerDetails} element={<FlyerDetails />} />
              <Route path={APP_ROUTES.maps} element={<Maps />} />
            </Routes>
            {openLoginDrawer && <LoginDrawer />}
          </div>
        </div>
      </div>

      {shouldShowBottomNav && <BottomNavigation />}
    </div>
  );
}

const styles = {
  container: css`
    display: flex;
    flex-direction: column;
    flex-grow: 1;
    @media screen {
      background: #fff;
    }
  `,
  backbutton: css`
    margin-left: 12px;
    margin-bottom: 32px;
  `,
  app: css`
    display: flex;
    flex-flow: column nowrap;
    min-height: 100vh;
    @media screen {
      background: #f5f5f5;
    }
  `,
  wrapper: css`
    display: flex;
    flex-direction: column;
    flex-grow: 1;
    @media screen {
      align-items: center;
    }
  `,
  content: css`
    flex: 1 1 auto;
    display: flex;
    flex-flow: column nowrap;
    max-width: 812px;
    width: 100%;
  `,
};

export default NonAutenticatedLayout;
